var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7129 8.49072H11.2011C9.68283 8.49072 8.44763 9.72592 8.44763 11.2441V20.756C8.44763 22.2742 9.68283 23.5097 11.2011 23.5097H20.7129C22.2311 23.5097 23.4667 22.2745 23.4667 20.756V11.2441C23.4667 9.72592 22.2315 8.49072 20.7129 8.49072ZM15.957 20.9444C13.2309 20.9444 11.013 18.7265 11.013 16.0001C11.013 13.274 13.2309 11.0561 15.957 11.0561C18.6834 11.0561 20.9013 13.274 20.9013 16.0001C20.9013 18.7261 18.683 20.9444 15.957 20.9444ZM19.8901 10.9085C19.8901 11.5535 20.4149 12.0783 21.0603 12.0783C21.7052 12.0783 22.23 11.5535 22.23 10.9085C22.23 10.2635 21.7052 9.73872 21.0603 9.73872C20.4149 9.73872 19.8901 10.2635 19.8901 10.9085Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9569 13.1453C14.3832 13.1453 13.1018 14.426 13.1018 15.9997C13.1018 17.5741 14.3832 18.8551 15.9569 18.8551C17.5313 18.8551 18.8117 17.5741 18.8117 15.9997C18.8117 14.4263 17.531 13.1453 15.9569 13.1453Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.957C0 7.14453 7.14453 0 15.957 0C24.7694 0 31.914 7.14453 31.914 15.957C31.914 24.7694 24.7694 31.914 15.957 31.914C7.14453 31.914 0 24.7694 0 15.957ZM20.7129 25.5986C23.3835 25.5986 25.5556 23.4265 25.5556 20.7559V11.2441C25.5556 8.57387 23.3835 6.40142 20.7129 6.40142H11.2011C8.53084 6.40142 6.3584 8.57387 6.3584 11.2441V20.7559C6.3584 23.4265 8.53084 25.5986 11.2011 25.5986H20.7129Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d2cb6e6a6eb0681468525f317e7d6630.svg";
export { ForwardRef as ReactComponent };